import type { SwotCategory, SwotEntry } from './types';

export const SWOT_CATEGORIES: SwotCategory[] = [
  'fortaleza',
  'debilidad',
  'oportunidad',
  'amenaza',
];

export const SWOT_CATEGORY_LABEL: Record<SwotCategory, string> = {
  fortaleza: 'Fortalezas',
  debilidad: 'Debilidades',
  oportunidad: 'Oportunidades',
  amenaza: 'Amenazas',
};

export const SWOT_QUADRANT_LABEL: Record<SwotCategory, string> = {
  fortaleza: 'Interno · Positivo',
  debilidad: 'Interno · Negativo',
  oportunidad: 'Externo · Positivo',
  amenaza: 'Externo · Negativo',
};

export type SwotGroupedByCategory = Record<SwotCategory, SwotEntry[]>;

export function groupSwotByCategory(entries: SwotEntry[]): SwotGroupedByCategory {
  const grouped: SwotGroupedByCategory = {
    fortaleza: [],
    debilidad: [],
    oportunidad: [],
    amenaza: [],
  };

  for (const entry of entries) {
    if (!entry.active) continue;
    grouped[entry.category].push(entry);
  }

  return grouped;
}
